import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './bootstrap/global.styles.css';
import './index.css';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
   <React.StrictMode>
      <Provider store={store}>
         <Router>
            <App />
         </Router>
      </Provider>
   </React.StrictMode>,
   document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
